import { type Notification } from '@flemingmetrics/api-client';
import { API } from '@/api';
import { buildIsReadFilter } from '@/utils/filters';
import { sortByCreatedAt } from '@/utils/arrays';
import { PAGE_SIZE } from './constants';

export const classes = {
  wrapper:
    'place-center w-10 h-10 rounded-full bg-mint-2/10 hover:bg-mint-2/20 transition-colors cursor-pointer',
  icon: 'text-mint-2',
};

export const styles = {
  unread: {
    animationName: 'ring-notification-bell',
    animationDuration: '1.2s',
    animationTimingFunction: 'ease-in-out',
  },
};

const isReadFilter = buildIsReadFilter(false);

export function sortNotifications(notifications: Notification[]) {
  return sortByCreatedAt(notifications).slice(0, PAGE_SIZE);
}

export async function fetchNotifications() {
  // One request to get all notifications, one just to get the count of unread notifications
  const [allNotifications, unreadNotifications] = await Promise.all([
    API.Notifications.fetchNotifications({
      filters: [],
      pagination: { page: 1, pageSize: PAGE_SIZE },
    }),
    API.Notifications.fetchNotifications({
      filters: [isReadFilter],
      pagination: { page: 1, pageSize: 1000 }, // NOTE: Using an arbitrarily large page size to get the count
    }),
  ]);
  return {
    notifications: allNotifications.results,
    unreadCount: unreadNotifications.pagination.rowCount,
  };
}
